<style scoped>
.success-banner {
  width: 100%;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.icon-container {
  background: #6abf69;
  padding: 20px;
}

.check-icon {
  width: 40px;
  height: 40px;
}

.message {
  padding: 15px;
  font-family: Arial, sans-serif;
  color: #333;
}

.message h2 {
  font-size: 18px;
  margin: 10px 0;
  font-weight: bold;
}

.message p {
  font-size: 14px;
  color: #666;
}
</style>
<template>

  <div class="container">

    <DeslindeDialog :isOpen="dialogOpen" :index="1" :textoDeslinde="signatureData.texto_deslinde_online"
      :datosPersona="signatureData.persona" @close="handleCloseDeslinde" @accept="handleAcceptDeslinde" />

    <div v-if="showSuccessAlert" class="success-banner">
      <div class="icon-container">
        <svg class="check-icon" viewBox="0 0 24 24">
          <path fill="white" d="M9 16.2l-4.2-4.2-1.4 1.4L9 19 21 7l-1.4-1.4z" />
        </svg>
      </div>
      <div class="message">
        <h2>Todo salio bién</h2>
        <p>gracias por actualizar tu firma!</p>
      </div>
    </div>

    <div v-if="loading">
      <p>Cargando datos...</p>
    </div>


    <div v-if="!loading && signatureData">

    </div>

    <div v-if="!loading && !signatureData.texto_deslinde_online">
      <p>No se encontraron datos.</p>
    </div>

  </div>
</template>

<script>

import api from '../../../api/deslinde';
import DeslindeDialog from '../../public/evento/inscripcion-evento/components/DeslindeDialog.vue';

export default {

  components: {
    DeslindeDialog
  },

  props: {


  },

  data() {
    return {
      loading: true,
      signatureData: {
        persona: {
          nombre: "",
          apellido: ""
        },
        texto_deslinde_online: ""
      },
      token: null,
      dialogOpen: false
    }
  },
  mounted() {
    // Supone que el token se pasa en la URL como query param (e.g., ?token=...)
    const token = this.$route.params.token;
    if (token) {
      this.token = token;
      this.fetchData(token);

    } else {
      console.error("Token no encontrado en la URL");
    }
  },
  methods: {
    async fetchData(token) {


      api.getDeslindeSignatureByToken(token)
        .then(response => {
          this.signatureData = response.data.results;
          this.dialogOpen = true;
          this.loading = false;
        })
        .catch(error => {
          console.error("Error al obtener la información:", error);
          this.$router.push({ name: "not-found" });
        }).finally(() => {
          this.loading = false;
        });

    },

    handleCloseDeslinde() {
      this.dialogOpen = false;
    },
    handleAcceptDeslinde({ index, signature }) {
      const newSignatureData = {
        access_token: this.token,
        signature_data: signature
      };



      api.updateDeslindeSignature(newSignatureData)
        .then(response => {
          console.log("Firma actualizada:", response.data);
          this.dialogOpen = false;
          this.showSuccessAlert = true;
        })
        .catch(error => {
          console.error("Error al actualizar la firma:", error);
        });
    },
  }
}

</script>